<script>
import { Doughnut } from 'vue-chartjs'
import { Bus } from '../../bus'

export default {
  extends: Doughnut,
  props: {
    topics: {
      required: true,
      type: Array
    }
  },
  mounted () {
    this.renderChart({
      labels: this.createLabels(),
      datasets: [{
        data: this.createChartData(),
        backgroundColor: [
          'rgba(197,17,98,0.2)',
          'rgba(170,0,255,0.2)',
          'rgba(48,79,254,0.2)',
          'rgba(0,145,234,0.2)',
          'rgba(0,191,165,0.2)',
          'rgba(100,221,23,0.2)',
          'rgba(255,214,0,0.2)',
          'rgba(255,109,0,0.2)',
          'rgba(221,44,0,0.2)',
          'rgba(46,61,52,0.2)',
          'rgb(105,105,105, 0.2)'

        ],
        borderColor: [
          'rgba(197,17,98,1)',
          'rgba(170,0,255,1)',
          'rgba(48,79,254,1)',
          'rgba(0,145,234,1)',
          'rgba(0,191,165,1)',
          'rgba(100,221,23,1)',
          'rgba(255,214,0,1)',
          'rgba(255,109,0,1)',
          'rgba(221,44,0,1)',
          'rgba(46,61,52,1)',
          'rgb(105,105,105,1)'
        ],
        borderWidth: 1
      }]
    }, this.createChartOptions())
  },
  methods: {
    createChartOptions () {
      return {
        responsive: true,
        onClick: (a, chartElement) => {
          console.log(chartElement)
          try {
            this.notifyTopicChanged(chartElement)
          } catch (e) {
            console.warn('Clicked on non topic area.')
          }
        },
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            }
          }]
        }
      }
    },
    createLabels () {
      return this.topics.map((topic, index) => 'Topic ' + (index + 1))
    },
    createChartData () {
      return this.topics.map(topic => topic.frequency)
    },
    notifyTopicChanged (chartElement) {
      let elementId = chartElement[0]._index
      let elementColor = chartElement[0]._view.backgroundColor
      let elementBorderColor = chartElement[0]._view.borderColor
      Bus.$emit('topic-clicked', {
        'id': elementId,
        'backgroundColor': elementColor,
        'borderColor': elementBorderColor
      })
    }

  }
}
</script>
